var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToothbrush02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#231f20;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.8 997v2h-399V857h50.8l23.1 23.1 23.1-23.1h38l23.1 23.1L422 857h38.1l23 23.1 23.1-23.1h38.1l23 23.1 23.1-23.1h49.4z",
    id: "Layer_4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1703.1 999H217"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639.8 997V857h-49.4l-23.1 23.1-23-23.1h-38.1l-23.1 23.1-23-23.1H422l-23.1 23.1-23.1-23.1h-38l-23.1 23.1-23.1-23.1h-50.8v140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4 888.8v98.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.7 888.8v98.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.2 888.8v98.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M568.1 888.8v98.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothbrush02);
export default __webpack_public_path__ + "static/media/toothbrush-02.7d14155b788c0fe84b73db8b5a2084c1.svg";
export { ForwardRef as ReactComponent };